import { Component, OnDestroy } from '@angular/core';
import { AuthService } from '../../features/auth/auth.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-404',
  standalone: true,
  templateUrl: './error-404.component.html',
  styleUrls: ['./error-404.component.css']
})
export class Error404Component implements OnDestroy{
  countdown = 3;
  private intervalId?: number;
  private isActiveTab = true;

  constructor(private authService: AuthService, private router: Router) {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');

    if (code) {
      this.router.navigate(['/']);
    } else {
      this.setupVisibilityListener();
      this.startCountdown();
    }

  }

  private setupVisibilityListener(): void {
    document.addEventListener('visibilitychange', () => {
      this.isActiveTab = !document.hidden;
    });
  }

  private startCountdown(): void {
    this.intervalId = window.setInterval(() => {
      if (this.isActiveTab) {
        this.countdown--;
        if (this.countdown === 0) {
          this.stopCountdown();
          this.redirectToLogin();
        }
      }
    }, 1000);
  }

  private stopCountdown(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = undefined;
    }
  }

  private redirectToLogin(): void {
    window.location.href = environment.cognitoUrl; 
  }

  
  onLoginNowClick(): void {
    this.redirectToLogin();  
  }

  ngOnDestroy(): void {
    this.stopCountdown();
    document.removeEventListener('visibilitychange', () => {});
  }
}
